import React from 'react';

import { Form, Input, Modal } from 'antd';

import { CreateProductFormValues } from '../types';

interface CreateProductModalProps {
  visible: boolean;
  loading: boolean;
  onCancel: () => void;
  onSubmit: (values: CreateProductFormValues) => void;
}

const CreateProductModal: React.FC<CreateProductModalProps> = ({
  visible,
  loading,
  onCancel,
  onSubmit,
}) => {
  const [form] = Form.useForm<CreateProductFormValues>();

  const handleOk = () => {
    form.validateFields().then((values) => {
      onSubmit(values);
      form.resetFields();
    });
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title="Создать продукт"
      visible={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      okText="Создать"
      cancelText="Отмена"
      confirmLoading={loading}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        requiredMark={false}
      >
        <Form.Item
          name="name"
          label="Название продукта"
          rules={[{ required: true, message: 'Введите название продукта' }]}
        >
          <Input placeholder="Например: Курс по маркетингу" />
        </Form.Item>
        <Form.Item
          name="url"
          label="Ссылка на продукт"
          rules={[
            { required: true, message: 'Введите ссылку на продукт' },
            { type: 'url', message: 'Введите корректный URL' },
          ]}
        >
          <Input placeholder="https://example.com/product" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateProductModal;
